import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.scss';

export const SimpleFooter = () => {
    const { t } = useTranslation();
    return (
        <footer className="container__footer">
            <span className="footer--text">{t('footer.copyright')}</span>
        </footer>
    );
};

export default SimpleFooter;
